export class UpdateServiceCenterCustomCommand {
    serviceCenterId: number;
    isActual: boolean;
    updateIsActual: boolean;
    isOneRoleSC: boolean;
}